import request from '@/utils/request';

export default {
  /**
   * 得到某个CAN配置的信息
   * @param canConfigId
   * @return {*}
   */
  getCANConfig(canConfigId) {
    return request.get(`project/can/${canConfigId}/config`);
  },
  /**
   * 更新某个CAN配置
   * @param canConfigId 通道配置id
   * @param mode 模式
   * @param baudRate 波特率
   * @param canIndex
   * @param isPlay
   * @return {*|Promise<any>}
   */
  setCANConfig(canConfigId, mode, baudRate, dataBaudRate, canIndex, isPlay) {
    return request.post('project/can/saveConfig', {
      id: canConfigId,
      mode,
      baudRate,
      dataBaudRate,
      canIndex,
      isPlay,
    });
  },
  /**
   * 罗列与指定工程相符合的可用的CAN列表。在添加通道时会调用，并排除了当前工程下已经包含的通道
   * @param projectId
   * @return {*|Promise<any>}
   * @deprecated 已经取消
   */
  listCAN(projectId) {
    return request.get(`project/${projectId}/listCan`);
  },
  /**
   * 罗列该工程下可用的设备，被使用的设备的used字段=true
   * 返回的数据结构：
   * {
   *   success:true,
   *   data:[
   *     {
   *       id:'123',
   *       text:'设备名字',
   *       used:true
   *     }
   *   ]
   * }
   *
   * @param projectId
   * @return {*|Promise<any>}
   */
  listDevice(projectId) {
    return request.get(`project/${projectId}/devices`);
  },
  /**
   * 给工程增加设备。调用成功后，请刷新左侧树状结构
   * @param projectId
   * @param deviceId
   * @return {*|Promise<any>}
   */
  addDevice(projectId, deviceId) {
    return request.post('project/device/add', {
      projectId,
      deviceId,
    });
  },
  /**
   * 移除工程中的某个设备。调用成功后，请刷新左侧树状结构
   * @param projectId
   * @param deviceId
   * @return {*|Promise<any>}
   */
  removeDevice(projectId, deviceId) {
    return request.post('project/device/remove', {
      projectId,
      deviceId,
    });
  },

  removeDbc(id) {
    return request.postJson('/project/delete/can/dbc', { id });
  },
  // /**
  //  * 增加通道
  //  * @param projectId
  //  * @param deviceId 服务器上的设备id
  //  * @param canIndex
  //  * @return {*}
  //  */
  // addCAN(projectId, deviceId, canIndex) {
  //   return request.post('project/can/add', {
  //     projectId,
  //     deviceID: deviceId,
  //     canIndex,
  //   });
  // },
  /**
   * 切换工作页或参考页
   * @param canConfigId
   * @param targetPage
   * @return {*}
   */
  switchPage(canConfigId, targetPage) {
    return request.post('project/can/switchPage', {
      id: canConfigId,
      targetPage,
    });
  },
  /**
   * 对一个通道配置上，绑定一个A2L文件地址
   * @param canConfigId
   * @param path
   * @return {*}
   */
  addA2L(canConfigId, path) {
    return request.post('project/can/addA2L', {
      canConfigId,
      path,
    });
  },
  /**
   * 对一个通道的配置绑定解析该A2l的Excel
   * @param canConfigId can通道Id
   * @param path 文件path
   * @returns {*|Promise<any>}
   */
  addExcelBindA2L(canConfigId, path) {
    return request.post('project/can/addA2lExcel', {
      canConfigId,
      path,
    });
  },
  /**
   * 对一个通道配置上，绑定一个DBC文件地址
   * @param canConfigId
   * @param path
   * @return {*}
   */
  addDBC(canConfigId, path) {
    return request.post('project/can/addDBC', {
      canConfigId,
      path,
    });
  },
  /**
   * 对一个通道配置上，绑定一个UDS模板文件地址
   * @param canConfigId
   * @param path
   * @return {*}
   */
  addUDS(canConfigId, path) {
    return request.post('project/can/addUDS', {
      canConfigId,
      path,
    });
  },
  /**
   * 得到工程详情，即左侧树状结构以及面板列表
   * @param projectId
   * @return {*}
   */
  getDetail(projectId) {
    return request.get(`project/${projectId}/detail`);
  },
  /**
   * 获取UDS模板中的数据，用于开展UDS诊断命令下发
   * @param canConfigId
   * @returns {*}
   */
  getUdsTemplateData(canConfigId) {
    return request.get(`project/uds/${canConfigId}/getTemplateData`);
  },
  /**
   * 将UDS诊断请求发送给服务器
   * @returns {*|Promise<any>}
   */
  sendUDSCommand(canConfigId, udsCommand) {
    return request.postJson('project/uds/sendCommand', {
      canConfigId,
      udsCommand,
    });
  },
  /**
   * 针对A2L进行事件绑定
   * @param canConfigId
   * @param eventBindData
   * @return {*}
   */
  bindA2LEvent(canConfigId, eventBindData) {
    return request.postJson('project/a2l/bindEvent', {
      canConfigId,
      eventBindDTOS: eventBindData,
    });
  },
  /**
   * 得到A2L节点的配置信息
   * @param canConfigId
   * @return {*}
   */
  getA2LConfig(canConfigId) {
    return request.get(`project/a2l/${canConfigId}/configDetail`);
  },

  /**
   * 上传文件
   * @param projectId
   * @param fileBlob
   * @param type 1=DBC文件，2=A2L文件 3=UDS文件
   * @return {*}
   */
  uploadFile(projectId, fileBlob, type) {
    const formData = new FormData();
    formData.append('file', fileBlob);
    formData.append('projectId', projectId);
    formData.append('type', type);
    return request.postForm('project/uploadFile', formData);
  },
  /**
   * 上传A2L的文件夹，废弃
   * @param projectId
   * @param folder
   * @return {null}
   */
  uploadA2LFolder(projectId, folder) {
    return null;
  },
  /**
   * 发送组件发送信息
   * @param id   组件id
   * @param data  发送组件发送的数据列表
   * @returns {*|Promise<any>}
   */
  sendSubmitMsg(id, data, times, cycle, nohup) {
    return request.postJson('component/send/sendMsg', { id, data, times, cycle, nohup });
  },
  /**
   * 停止组件的发送
   * @param id 组件id
   */
  stopSendMsg(id, data, times, cycle, nohup) {
    return request.postJson('component/send/sendStop', { id, data, times, cycle, nohup });
  },
  /**
   * 保存自定义帧信息
   */
  saveFrame(componentId, definedDataParams) {
    return request.postJson('component/saveDefinedSendConfig', { componentId, definedDataParams });
  },
  /**
   * 获取自定义帧信息
   */
  getFrame(componentId) {
    return request.get(`component/${componentId}/getSendDefinedConfig`);
  },
  /**
   * 发送自定义帧
   * @param  SendDefinedDataMsgParam
   * @returns {*|Promise<any>}
   */
  sendFrame(SendDefinedDataMsgParam) {
    return request.postJson('component/send/sendDefinedData', SendDefinedDataMsgParam);
  },
  /**
   * 停止发送自定义帧
   */
  stopSendFrame(SendDefinedDataMsgParam) {
    return request.postJson('/component/send/stopDefinedData', SendDefinedDataMsgParam);
  },

  /**
   * 根据面板id返回当前面板的状态
   * @param panelId 面板id
   * @returns {*|Promise<any>}
   */
  panelIdStatus(panelId) {
    return request.get(`panel/${panelId}/state`);
  },
  /**
   * 根据工程id返回当前工程的状态
   * @param projectId 工程id
   * @returns {*|Promise<any>}
   */
  projectIdStatus(projectId) {
    return request.post('project/getProjectStatus', {
      projectId,
    });
  },
  /**
   * 标定量组件修改
   * @param componentId
   * @param datasource
   * @param parentKey
   * @param value
   * @returns {*|Promise<any>}
   */
  setBindValue(componentId, datasource, parentKey, value) {
    return request.post('component/input/setValue', { componentId, datasource, parentKey, value });
  },
  /**
   * 根据工程ID获取当前工程下所有通道的状态
   * @param projectId
   * @returns {*|Promise<any>}
   */
  getAllCanStatus(projectId) {
    return request.get(`project/${projectId}/can/page/state`);
  },
  /**
   * 下发当前工程配置下的所有MDF配置，并使用默认参数
   * @param projectId
   * @return {*|Promise<any>}
   */
  downloadMDFConfigToDeviceAll(projectId) {
    return request.post(`project/${projectId}/MDFConfig/downloadAll`);
  },
  /**
   * 获取左侧树的配置数据
   * @param projectId
   * @returns {*|Promise<any>}
   */
  getTreeConfigData(projectId) {
    return request.get(`project/${projectId}/MDFConfig`);
  },
  /**
   * 保存文件录制的配置
   * @param data
   * @returns {*|Promise<any>}
   */
  saveTreeConfigData(data) {
    return request.postJson('project/DeviceFilePLay/Update', data);
  },
  /**
   * 将文件下发给设备
   * @param projectId 工程id
   * @param deviceId 设备id
   * @returns {*|Promise<any>}
   */
  configToDevice(projectId, deviceId) {
    return request.post(`project/${projectId}/DeviceFilePlay/download`, { deviceId });
  },
  /**
   * 保存UDS诊断命令
   * @param panelId 面板Id
   * @param commandArr 诊断命令数组
   * @returns {*|Promise<any>}
   */
  saveUdsCommand(panelId, commandArr) {
    return request.postJson('project/saveUdsCommand', { panelId, commandArr });
  },

  /**
   * 获取UDS诊断命令
   * @param panelId 面板Id
   * @returns {*|Promise<any>}
   */
  getUdsCommand(panelId) {
    return request.postJson('project/getUdsCommand', panelId);
  },

  /**
   * 获取GPS的设备信息
   */
  getGpsDeviceInfo(componentId) {
    return request.post('project/getGpsDeviceInfo', { componentId });
  },

  /**
   * 获取地图的Mock数据
   */
  getMapMockData(panelId, componentId, keyList, times, interval) {
    return request.postJson('project/getMapMockData', { panelId, componentId, keyList, times, interval });
  },

  /**
   * 保存地图的设备与信号关系
   */
  setMapConfig(componentId, deviceConfigs) {
    return request.postJson('/component/save/mapConfig', { componentId, deviceConfigs });
  },

  /**
   * 获取地图的设备与信号关系
   */
  getMapConfig(componentId) {
    return request.post(`/component/get/${componentId}/mapConfig`);
  },
  // /**
  //  * Control组件发送信息
  //  * @param projectId   项目id
  //  * @param key  信号key
  //  * @param value  信号value
  //  * @returns {*|Promise<any>}
  //  */
  // sendControlMsg(projectId, key, value) {
  //   return request.postJson('/component/send/controller/frameMsg', { projectId, key, value });
  // },
  /**
   * 通过trigger变量进行发送
   */
  sendTrigger(projectId, triggerId) {
    return request.postJson('component/trigger/send/frame', { projectId, triggerId });
  },

  /**
   * 保存该project下的Control组件信号的值
   */
  saveControlMsg(projectId, signalId, value) {
    return request.postJson('component/save/singleLetter/value', { projectId, signalId, value });
  },

  /**
   * 获取该project下的Control组件信号的值
   */
  getControlMsg(projectId, signalId) {
    return request.postJson('component/getSingleSignalValue', { projectId, signalId });
  },

  /**
   * 保存自定义组件样式信息
   */
  saveCptStyle(projectId, panelId, componentStyleParams) {
    return request.postJson('panel/save/componentStyle/Config', { projectId, panelId, componentStyleParams });
  },

  /**
   * 获取自定义组件样式信息
   */
  getCptStyle(projectId, panelId) {
    return request.postJson(`panel/getComponent/style/config/${projectId}/${panelId}`);
  },

  /**
   * 保存自定义组件信号名
   */
  saveCptName(projectId, panelId, componentId, signalKey, name) {
    return request.postJson('component/signal/rename', { projectId, panelId, componentId, signalKey, name });
  },

  /**
   * 读取自定义组件信号名
   */
  getCptName(projectId, panelId) {
    return request.postJson('panel/renameSignalList', { projectId, panelId });
  },

  /**
   * 获取标定量初始值接口
   */
  getBindIni(projectId) {
    return request.postJson(`/project/getChartInitValue/${projectId}`);
  },

  /**
   * 标定组件测试接口
   */
  bindTest(projectId) {
    return request.postJson(`test/startAck/${projectId}`);
  },

  /**
   * 条件判断组件保存配置
   */
  saveConditionConfig(componentId, signalConditions) {
    return request.postJson('/component/save/condition/config', { componentId, signalConditions });
  },

  /**
   * 条件判断组件获取配置
   */
  getConditionConfig(componentId) {
    return request.postJson(`/component/get/${componentId}/condition/config`);
  },

  /**
   * 条件判断组件下发配置
   */
  issueConditionConfig(componentId) {
    return request.postJson(`/component/download/component/${componentId}/conditionConfig`);
  },
};



// WEBPACK FOOTER //
// ./src/api/projectDetail.js